import { useCallback, useRef } from "react";
import type { SubmitFunction, SubmitOptions, SubmitTarget } from "react-router";

export function useFetcherPromise<
	T,
	TData extends SubmitTarget = SubmitTarget,
>() {
	const pendingPromiseRef = useRef<{
		resolve: (value: T) => void;
		// biome-ignore lint/suspicious/noExplicitAny:
		reject: (reason?: any) => void;
	} | null>(null);

	const submit = useCallback(
		(
			fetcher: { submit: SubmitFunction },
			formData: TData,
			options: SubmitOptions,
		): Promise<T> => {
			return new Promise((resolve, reject) => {
				pendingPromiseRef.current = { resolve, reject };
				fetcher.submit(formData, options);
			});
		},
		[],
	);

	const resolve = useCallback((data: T) => {
		pendingPromiseRef.current?.resolve(data);
		pendingPromiseRef.current = null;
	}, []);

	const reject = useCallback((error: Error) => {
		pendingPromiseRef.current?.reject(error);
		pendingPromiseRef.current = null;
	}, []);

	return { submit, resolve, reject };
}
